import { useNavigate } from "react-router-dom";

export const ReportsRoutesComponent = () => {
	const navigate = useNavigate();
	const ArrayData = [
		{
			label: "Employees",
			items: [
				{
					label: "Setup",
					command: () => {
						navigate("/reports/employee/setup");
					},
				},
				{
					label: "Salary",
					command: () => {
						navigate("/reports/salary");
					},
				},
			],
		},
		{
			label: "Payroll ",
			items: [
				{
					label: "EDR",
					command: () => {
						navigate("/reports/edr");
					},
				},
			],
		},
		{
			label: "Accounting",
			items: [
				{
					label: "Invoice",
					command: () => {
						navigate("/reports/invoice-report");
					},
				},
			],
		},

		{
			label: "Remittance",
			items: [
				{
					label: "EHT Ontario",
					command: () => {
						navigate("/reports/eht-ontario");
					},
				},
				{
					label: "CRA",
					command: () => {
						navigate("/reports/cra");
					},
				},
				{
					label: "RQ",
					command: () => {
						navigate("/reports/rq");
					},
				},
			],
		},
		{
			label: "Compliance ",
			items: [
				{
					label: "T4",
					command: () => {
						navigate("/reports/compliance/t4");
					},
				},
				{
					label: "RL1",
					command: () => {
						navigate("/reports/compliance/rl1");
					},
				},
				{
					label: "TD1 ",
					command: () => {
						navigate("/reports/compliance/td1");
					},
				},
			],
		},
		// {
		// 	label: "Salary Profile",
		// 	command: () => {
		// 		navigate("/reports/salary-profile");
		// 	},
		// },
	];

	return {
		ReportsRoutes: ArrayData,
	};
};
